import axios from 'axios';

import { getSchedulingServerURL } from '../../HarverPages/shared/helper';

export async function reschedule(calendarEventId: string, reason: string): Promise<string> {
    const { data } = await axios.post(`${getSchedulingServerURL()}/interview/reschedule`, {
        calendarEventId,
        reason,
    });

    return data.rescheduledLink;
}
